import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import InsuranceOfferCard from 'partial/OfferManager/modules/InsuranceModuleRedesign/InsuranceOfferCard';
import './insuranceCarousel.scss';
import Label from 'components/form/Label/Label';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { AUTO_INSURANCE_VERTICAL } from 'types/mrph.vertical.constants';

const InsuranceOfferSummary = props => {
  const { offerTiles, onLinkClickCallback } = props;
  return offerTiles.map((item, index) => {
    return (
      <InsuranceOfferCard
        key={'insuranceOfferCard' + index}
        tileIconKey={item?.icons?.tileIcon}
        title={item?.titleText}
        text={item?.subTitleText}
        containerClasses="system_neutral_n000 margt12 margb4 grayShadow16 border-rad8px pointer insuranceCard"
        url={item?.tileUrlWeb}
        onLinkClickCallback={onLinkClickCallback}
      />
    );
  });
};

const InsuranceModuleView = props => {
  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName: 'Insurance Options',
    pagePosition: 'Auto Loan Purchase',
    Vertical: AUTO_INSURANCE_VERTICAL,
    modulePosition: props.modulePosition,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);
  return (
    <FlexContainer className="flex-column horizontalScrollBar">
      {seenModuleTracking}
      <Label
        className="m-pos-sticky left0 marg0 m-text-12 system_neutral_n500_text"
        type="H4"
        typeHeader={'h2'}
      >
        Insurance options
      </Label>
      <FlexContainer className="AutoInsuranceContainer gap-12 justify-between padlr2">
        <InsuranceOfferSummary {...props} />
      </FlexContainer>
    </FlexContainer>
  );
};

export default InsuranceModuleView;
